module.exports = __webpack_public_path__ + "img/ic_user_setting.0b7eea5b.svg";